/**
 * Gold "Document Verified" circular seal watermark overlay.
 * Renders absolute inside a relatively-positioned parent image container.
 * size: 'sm' | 'md' (default md)
 */
export const VerifiedSeal = ({ size = "md" }) => (
  <div className={`verified-seal ${size === "sm" ? "sm" : ""}`} aria-hidden="true" data-testid="verified-seal">
    <svg viewBox="0 0 100 100" width="100%" height="100%">
      {/* Rotating outer ring with text */}
      <defs>
        <path id="seal-arc" d="M50,50 m-38,0 a38,38 0 1,1 76,0 a38,38 0 1,1 -76,0" fill="none" />
        <radialGradient id="seal-gold" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#F4D086" />
          <stop offset="60%" stopColor="#D4A359" />
          <stop offset="100%" stopColor="#8a6420" />
        </radialGradient>
      </defs>
      <g className="seal-ring">
        <circle cx="50" cy="50" r="46" fill="none" stroke="#D4A359" strokeWidth="1.2" strokeDasharray="2 3" opacity="0.9" />
        <text fontSize="7.5" fill="#2B1E1A" fontFamily="Plus Jakarta Sans, sans-serif" fontWeight="700" letterSpacing="2">
          <textPath href="#seal-arc" startOffset="0">NAMMA MYSURU · DOCUMENT VERIFIED · ₹1,999 TIER · </textPath>
        </text>
      </g>
      {/* Inner circle */}
      <circle cx="50" cy="50" r="30" fill="url(#seal-gold)" stroke="#2B1E1A" strokeWidth="1.5" />
      {/* Checkmark */}
      <path d="M38 50 L46 58 L62 42" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <text x="50" y="73" textAnchor="middle" fontSize="7" fill="#2B1E1A" fontFamily="Cormorant Garamond, serif" fontWeight="600" fontStyle="italic">
        Verified
      </text>
    </svg>
  </div>
);
